import { CoreMenu } from '@core/types';

export const menu: CoreMenu[] = [
  {
    id: 'example',
    title: 'Example',
    translate: 'MENU.EXAMPLE',
    type: 'section',
    role: ['AdminRole'],
    children: [
      {
        id: 'table',
        title: 'Table',
        translate: 'MENU.TABLE',
        type: 'item',
        icon: 'list',
        url: 'example/table',
        role: ['AdminRole'],
        exactMatch: false,
      },
      {
        id: 'form',
        title: 'Form',
        translate: 'MENU.FORM',
        type: 'item',
        icon: 'file-text',
        url: 'example/form/new',
        role: ['AdminRole'],
        exactMatch: false,
      },
    ],
  }
];
